import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=1967d262&scoped=true&"
import script from "./Gallery.vue?vue&type=script&lang=js&"
export * from "./Gallery.vue?vue&type=script&lang=js&"
import style0 from "./Gallery.vue?vue&type=style&index=0&id=1967d262&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1967d262",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/bomba-nygma/bomba-nygma-vitrine/client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VContent } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VParallax } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VChip,VContainer,VContent,VFlex,VIcon,VImg,VLayout,VParallax,VProgressCircular})
